export default "__VITE_PUBLIC_ASSET__80c01eb4__"